import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Stepper,
  Step,
  StepLabel,
  useMediaQuery,
  IconButton,
  Tooltip,
  Snackbar,
  useTheme,
  Stack,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DashboardLayout } from '../layoutV2/DashboardLayout';
import { getReferral } from '../services/CustomerService';
import ConnectWithoutContactRoundedIcon from '@mui/icons-material/ConnectWithoutContactRounded';
import ShareButton from '../components/profile/profile-sections/ShareButton';
import ShareIcon from '@mui/icons-material/Share';
import { getUserDetails } from '../services/UserDetailsService';
import {
  getCustomerDetails,
  getReferralCode,
} from '../services/CustomerService';
import AssignmentIcon from '@mui/icons-material/Assignment';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import ReferralProgram from '../Image/ReferralProgram.png';
import Footer from '../components/Footer';
import { InsertDriveFile } from '@mui/icons-material';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import { renderToStaticMarkup } from 'react-dom/server';

const steps = ['Signed up', 'Quote sent', 'Confirmed'];

const ReferralDashboardPage = () => {
  const myNetwork = useRef(null);
  const executeScrolltoMyNetwork = () => {
    const element = myNetwork.current;
    const elementRect = element.getBoundingClientRect();
    const offset = 280; // 40px above center
    const scrollTop = window.pageYOffset;
    const targetY =
      elementRect.top + scrollTop - window.innerHeight / 2 + offset;

    window.scrollTo({
      top: targetY,
      behavior: 'smooth',
    });
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [copied, setCopied] = useState(false);
  const [referralsData, setReferralsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userdetailsData, setUserDetailsData] = useState(null);
  const watermarkSvgString = renderToStaticMarkup(
    <svg xmlns='http://www.w3.org/2000/svg' fill='#1B833312'>
      <ConnectWithoutContactRoundedIcon
        fontSize='inherit'
        sx={{
          width: '100%',
          height: '100%',
        }}
      />
    </svg>,
  );
  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
  };

  useEffect(() => {
    const fetchAllData = async () => {
      setIsLoading(true);
      try {
        const { id } = getUserDetails();
        const [userDetails, referralData] = await Promise.all([
          getCustomerDetails(id),
          getReferral(id),
        ]);
        console.log('userDetails', userDetails);

        setUserDetailsData(userDetails);
        setReferralsData(referralData);
      } catch (error) {
        console.error('Failed to fetch data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllData();
  }, []);

  if (isLoading) {
    return (
      <DashboardLayout title='Referral Dashboard'>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='80vh'
        >
          <Typography>Loading...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  const referralLink = userdetailsData
    ? `https://www.vaysolar.com/en/getquote?fName=${encodeURIComponent(userdetailsData.fullName)}&r=${userdetailsData.referral_code}`
    : '';

  const generatReferralCode = async () => {
    try {
      const { id } = getUserDetails();
      const res = await getReferralCode(id);
      window.location.reload();
      return res;
    } catch (error) {
      console.error('Error fetching referral code:', error);
      throw error;
    }
  };

  const HowItWorks = () => {
    return (
      <Box
        mt={8}
        sx={{
          py: 8,
          textAlign: 'center',
          padding: isMobile ? 2 : 3,
        }}
      >
        <Typography variant='h4' fontWeight='bold' gutterBottom>
          How it works
        </Typography>

        <Grid container justifyContent='space-between' sx={{ mt: 4 }}>
          <Grid item xs={12} md={3.5}>
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <ShareIcon sx={{ fontSize: 40, color: '#1B8333', mb: 2 }} />
              <Typography variant='h5' fontWeight='bold' gutterBottom>
                Share
              </Typography>
              <Typography color='text.secondary' mb={2}>
                Send it to people who need solar—via WhatsApp, Facebook, email,
                or word of mouth.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3.5}>
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <SolarPowerIcon sx={{ fontSize: 40, color: '#1B8333', mb: 2 }} />
              <Typography variant='h5' fontWeight='bold' gutterBottom>
                Installation
              </Typography>
              <Typography color='text.secondary' mb={2}>
                They sign up using your link and confirm order to us
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={3.5}>
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <CardGiftcardIcon
                sx={{ fontSize: 40, color: '#1B8333', mb: 2 }}
              />
              <Typography variant='h5' fontWeight='bold' gutterBottom>
                Earn
              </Typography>
              <Typography color='text.secondary'>
                Get ₹3,000+ when they confirm an order. They also receive 20
                cleaning visits worth ₹10,000+{' '}
              </Typography>
            </Box>
          </Grid>
          <Stack width={'100%'} justifyContent='center' alignItems='center'>
            <Box
              display='flex'
              gap={2}
              flexDirection={isMobile ? 'column' : 'row'}
              width={isMobile ? '100%' : 'auto'}
              justifyContent={isMobile ? 'center' : 'flex-start'}
            >
              <ShareButton
                shareLink={`Hey! Main apna solar network VaySolar pe build kar raha hoon ☀
                      
Agar tum mere link se join karte ho, toh tumhe milega:
✅ ₹5000 tak ka discount on your solar system
✅ 20 cleaning visits worth ₹10,000+
✅ Free solar savings check (sirf 30 seconds mein)

Join karo aur solar mein smart investment ka pehla step lo 💡
${referralLink}`}
                shareprofile
                onClick={
                  !userdetailsData?.referral_code
                    ? generatReferralCode
                    : undefined
                }
              />
            </Box>
          </Stack>
        </Grid>
      </Box>
    );
  };
  return (
    <>
      <DashboardLayout title='Referral Dashboard'>
        <Box
          sx={{
            padding: isMobile ? 2 : 3,
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              width: isMobile ? '100%' : '65%',
              backgroundImage: `url('data:image/svg+xml;utf8,${encodeURIComponent(watermarkSvgString)}')`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: { md: '65%', xs: '100%' },
              backgroundPosition: isMobile ? 'center' : 'right top',
              pointerEvents: 'none',
            }}
          />

          <Grid sx={{ width: '100%', pr: isMobile ? 0 : '10rem' }}>
            <Typography
              sx={{
                fontFamily: 'Plus Jakarta Sans',
                fontWeight: 700,
                letterSpacing: '-0.5px',
                WebkitTextStroke: isMobile ? '0.6px black' : '1.4px black',
                color: '#000',
              }}
              variant={isMobile ? 'h3' : 'h1'}
              gutterBottom
            >
              Build your solar network, earn cash rewards
            </Typography>

            <Typography variant='body1' color='black' fontWeight={600} pb={2}>
              <br /> Share your unique referral with friends
              <br />
              They get rewards upto ₹15,000 on their installation
              <br />
              You earn ₹3,000 to ₹7,000 on each successful referral
            </Typography>

            <Box
              display='flex'
              gap={2}
              flexDirection={isMobile ? 'column' : 'row'}
              width={isMobile ? '100%' : 'auto'}
              justifyContent={isMobile ? 'center' : 'flex-start'}
            >
              <ShareButton
                shareLink={`Hey! Main apna solar network VaySolar pe build kar raha hoon ☀

Agar tum mere link se join karte ho, toh tumhe milega:
✅ ₹5000 tak ka discount on your solar system
✅ 20 cleaning visits worth ₹10,000+
✅ Free solar savings check (sirf 30 seconds mein)

Join karo aur solar mein smart investment ka pehla step lo 💡
${referralLink}`}
                shareprofile
                onClick={
                  !userdetailsData?.referral_code
                    ? generatReferralCode
                    : undefined
                }
              />
              {referralsData.length > 0 && (
                <Button
                  variant='outlined'
                  sx={{
                    fontWeight: 'bold',
                    color: '#1B8333',
                    borderColor: '#1B8333',
                    '&:hover': {
                      backgroundColor: '#1B8333',
                      color: 'white',
                      borderColor: '#1B8333',
                    },
                  }}
                  startIcon={<PeopleAltIcon />}
                  onClick={executeScrolltoMyNetwork}
                >
                  view your network
                </Button>
              )}
            </Box>
          </Grid>
        </Box>

        {referralsData.length > 0 && (
          <Box p={2} mt={2}>
            <Box
              ref={myNetwork}
              display='flex'
              justifyContent='space-between'
              flexDirection={isMobile ? 'column' : 'row'}
              mb={4}
              gap={isMobile ? 3 : 0}
            >
              <Box
                display='flex'
                flexDirection='column'
                alignItems={isMobile ? 'center' : 'flex-start'}
                textAlign={isMobile ? 'center' : 'left'}
                gap={2}
              >
                <Typography variant='h5' fontWeight='bold'>
                  {userdetailsData.fullName}’s solar network
                </Typography>

                <Box
                  display='flex'
                  gap={2}
                  flexDirection={isMobile ? 'column' : 'row'}
                  width={isMobile ? '100%' : 'auto'}
                  justifyContent={isMobile ? 'center' : 'flex-start'}
                >
                  <ShareButton
                    shareLink={`Hey! Main apna solar network VaySolar pe build kar raha hoon ☀
                      
Agar tum mere link se join karte ho, toh tumhe milega:
✅ ₹5000 tak ka discount on your solar system
✅ 20 cleaning visits worth ₹10,000+
✅ Free solar savings check (sirf 30 seconds mein)

Join karo aur solar mein smart investment ka pehla step lo 💡
${referralLink}`}
                    shareprofile
                  />
                </Box>
              </Box>

              <Box
                display='flex'
                flexDirection='column'
                alignItems={'center'}
                textAlign={isMobile ? 'center' : 'right'}
                gap={1}
              >
                <Typography variant='body1' fontWeight='bold'>
                  Your unique referral link:
                </Typography>

                <Box
                  display='flex'
                  alignItems='center'
                  bgcolor='white'
                  sx={{
                    border: '1px solid gray',
                    borderRadius: '8px',
                    p: 1,
                    wordBreak: 'break-all',
                    maxWidth: '100%',
                  }}
                >
                  <Typography variant='body2' sx={{ mr: 1 }}>
                    {referralLink.slice(0, 37) + '...'}
                  </Typography>
                  <Tooltip title='Copy to clipboard'>
                    <IconButton onClick={handleCopy} size='small'>
                      <ContentCopyIcon fontSize='small' />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </Box>

            <Snackbar
              open={copied}
              autoHideDuration={3000}
              onClose={() => setCopied(false)}
              message='Link copied!'
            />

            <Grid container spacing={2}>
              {referralsData.map((ref, idx) => (
                <Grid item xs={12} sm={6} md={4} key={idx}>
                  <Card
                    sx={{
                      // bgcolor: theme.palette.primary.lighter,
                      borderRadius: '16px',
                      elivation: 0,
                      boxShadow: 'none',
                      border: '1px solid lightGray',
                    }}
                  >
                    <CardContent>
                      <Box display='flex' justifyContent='space-between'>
                        <Typography
                          variant='h6'
                          sx={{
                            maxWidth: '150px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            fontWeight: 'bold',
                          }}
                        >
                          {ref.fullName}
                        </Typography>
                        <Typography variant='body2' sx={{ mb: 1 }}>
                          up to ₹3k to ₹4k
                        </Typography>
                      </Box>

                      <Typography variant='body2' mb={8}>
                        +{ref.phoneNumber}
                      </Typography>

                      <Typography variant='body2' gutterBottom>
                        {ref.email}
                      </Typography>
                      {/* <Stepper activeStep={0} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper> */}
                      <Box
                        display='flex'
                        justifyContent='space-between'
                        alignItems='center'
                        mb={2}
                      >
                        <ShareButton
                          shareLink={`Hey! Tumne abhi tak apna bijli bill savings check kiya kya?
VaySolar pe sirf 30 seconds lagte hain dekhne ke liye ki tumhara rooftop kitna paisa bacha sakta hai 💸
Check karo abhi: www.vaysolar.com/en/roi`}
                          shareLabel='Share solar benefits'
                          shareprofile
                        />
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}

        <HowItWorks />
      </DashboardLayout>
      <Footer />
    </>
  );
};

export default ReferralDashboardPage;
